export const getIsOpenDialogContent = (state) => state.admin.isOpenDialogContent;
export const getDialogContent = (state) => state.admin.DialogContent;
export const getDefaultValues = (state) => state.admin.defaultValues;